import settings from '@/settings'

let listarTodas = (headers, page) => {
  return fetch(`${settings.apetrusApi}/empresas/todas/?page=${page}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let ativarOuDesativar = (headers, id) => {
  return fetch(`${settings.apetrusApi}/empresas/ativaroudesativar/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const pegarBoqueios = (headers) => {
  return fetch(`${settings.apetrusApi}/empresas/pegarbloqueios/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const marcarComoVisto = (headers, id) => {
  return fetch(`${settings.apetrusApi}/empresas/marcarcomovisto/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers
  })
}

const editarEmpresa = (headers, data) => {
  return fetch(
    `${settings.apetrusApi}/empresas/editarempresa/?cnpj=${data.cnpj}`,
    {
      method: 'PUT',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(data)
    }
  )
}

const pegarEmpresa = (headers, cnpj) => {
  return fetch(`${settings.apetrusApi}/empresas/?cnpj=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const procurarEmpresasPorAdmTransferencia = (headers, payload) => {
  let url = `${settings.apetrusApi}/empresas/procurarEmpresasPorAdm/`
  Object.keys(payload.filtros).forEach((filter) => {
    url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${
      payload.filtros[filter]
    }`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const procurarEmpresasPorAdm = (headers, payload) => {
  let url = `${settings.apetrusApi}/empresas/todas/`
  Object.keys(payload.filtros).forEach((filter) => {
    url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${
      payload.filtros[filter]
    }`
  })
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const cadastrar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/empresas/cadastrar/`, {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const tornarParceira = (headers, data) => {
  return fetch(`${settings.apetrusApi}/empresas/atualizar/`, {
    method: 'PUT',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

const automacaoEmpresa = (headers, data) => {
  return fetch(`${settings.apetrusApi}/empresas/automacao-empresa/`, {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: JSON.stringify(data)
  })
}

let procurarEmpresasPorUsuario = (headers, payload) => {
  return fetch(
    `${settings.apetrusApi}/empresas/todas/?administrador=${payload.id_pessoa}&page=${payload.page}`,
    {
      method: 'GET',
      mode: 'cors',
      headers: headers
    }
  )
}

export default {
  listarTodas,
  ativarOuDesativar,
  pegarBoqueios,
  marcarComoVisto,
  editarEmpresa,
  pegarEmpresa,
  procurarEmpresasPorAdmTransferencia,
  procurarEmpresasPorAdm,
  cadastrar,
  tornarParceira,
  automacaoEmpresa,
  procurarEmpresasPorUsuario
}
